import { motion } from "framer-motion";
import { ASSETS } from "@/data/assets";
import { useLang } from "@/i18n/LanguageContext";
import { reveal } from "@/hooks/reveal";

export const About = () => {
  const { t } = useLang();
  const CHAPTERS = t.about.chapters.map((c, i) => ({ n: String(i + 1).padStart(2, "0"), ...c }));
  return (
    <section id="about" className="relative bg-black/30 py-24 md:py-32" data-testid="about-section">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Left sticky intro */}
          <div className="lg:col-span-5">
            <motion.div className="lg:sticky lg:top-28" {...reveal()}>
              <span className="font-mono-tech text-[11px] tracking-[0.35em] uppercase text-[var(--al-gold)]">
                {t.about.eyebrow}
              </span>
              <h2 className="font-cinzel font-bold text-white text-3xl sm:text-4xl lg:text-5xl mt-4 leading-[1.08]">
                {t.about.title[0]}<br />{t.about.title[1]}<br />{t.about.title[2]}
              </h2>
              <p className="font-body text-white/55 text-sm md:text-base leading-relaxed mt-6 max-w-md">
                {t.about.intro}
              </p>
              <img
                src={ASSETS.boxMultiAngle}
                alt="AlloLabs UK packaging — closed box, foam tray and filled vial tray"
                className="mt-10 w-full border border-white/10 object-cover"
                data-testid="about-image"
              />
            </motion.div>
          </div>

          {/* Right — numbered manifesto chapters */}
          <div className="lg:col-span-7 lg:col-start-7">
            <div className="space-y-px">
              {CHAPTERS.map((c, i) => (
                <motion.div
                  key={c.n}
                  {...reveal(i * 0.06)}
                  className="group border-t border-white/10 py-9 md:py-11 flex gap-6 md:gap-10"
                >
                  <span className="font-display font-extrabold text-white/15 text-3xl md:text-5xl leading-none group-hover:text-[var(--al-gold)]/60 transition-colors duration-500">
                    {c.n}
                  </span>
                  <div>
                    <h3 className="font-cinzel font-bold text-white text-xl md:text-2xl">
                      {c.title}
                    </h3>
                    <p className="font-body text-white/55 text-sm md:text-base leading-relaxed mt-3 max-w-xl">
                      {c.body}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
